module.exports = __webpack_public_path__ + "img/SPHTX.d45aaf97.svg";